import { render, staticRenderFns } from "./recoverpass.vue?vue&type=template&id=5b18ceca&"
import script from "./recoverpass.vue?vue&type=script&lang=js&"
export * from "./recoverpass.vue?vue&type=script&lang=js&"
import style0 from "./recoverpass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports